.dialogHeader {
	color: white;
	align-items: center;
	justify-content: center;
}

.dialogTitle {
	font-size: 1.1rem;
}

.dialogContent {
	font-size: 1.2rem;
	white-space: pre-wrap;
}

.dialogHeaderWarning {
	background-color: var(--dialog-warning);
}

.dialogHeaderError {
	background-color: var(--dialog-error);
}

.dialogHeaderInfo {
	background-color: var(--dialog-info);
}

.dialogHeaderSuccess {
	background-color: var(--dialog-success);
}
